"use client";

import React from "react";
import { FlagValues, useFlags } from "@stadium/services/launch-darkly/use-flags";

export { FeatureFlagProvider } from "@stadium/services/launch-darkly/feature-flag-provider";

export { useFeatureFlag } from "@stadium/services/launch-darkly/use-feature-flag";
export { withSyncFeatureFlag } from "@stadium/services/launch-darkly/utils";
export { default as withFeatureFlagToggle } from "@stadium/services/launch-darkly/feature-flag-toggle";
export { default as FeatureFlagWrapper } from "@stadium/services/launch-darkly/feature-flag-wrapper";
export { useFlags } from "@stadium/services/launch-darkly/use-flags";

export {
  useLDClient,
  withLDConsumer,
  LDProvider,
  type ProviderConfig,
} from "@stadium/services/launch-darkly/library-imports";

export const withFeatureFlags = <T,>(
  Component: React.ComponentType<T>,
): React.ComponentType<T & { flags: FlagValues }> => {
  const WrappedComponent = (props: T) => {
    const flags = useFlags();
    return <Component {...props} flags={flags} />;
  };
  return WrappedComponent as React.ComponentType<T & { flags: FlagValues }>;
};
